import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LdapService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public changePasssword(oldPassword: string, newPassword: string) {
    const body = {
      oldPassword,
      newPassword,
    };

    return this.http.put(this.endpoint(`api`, `ldap`, `password`), body);
  }

  public resetPassword(email: string): Observable<any> {
    return this.http.put(this.directEndpoint(`api`, `ldap`, `password`, `reset`), { email: encodeURIComponent(email) });
  }

  public changePasswordPublic(token: string, newPassword: string): Observable<any> {
    const body = {
      newPassword,
    };

    return this.http.put(this.directEndpoint(`api`, `ldap`, `password`, `reset`, `token`, `${token}`), body);
  }
}
